import styled, { css } from 'styled-components';

export const WishlistItemWrapper = styled.div<{ $isDefault?: boolean }>`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 25px 8px 8px;
    gap: 16px;
    max-width: 520px;
    width: 100%;
    /* height: 80px; */
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    transition: 0.3s;
    border: 1px solid transparent;
    position: relative;

    ${({ $isDefault }) =>
        $isDefault &&
        css`
            border-color: #523df1;
        `};

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        border-width: 2px;
        gap: 24px;
    }
`;

export const WishlistItemNumber = styled.div`
    font-weight: 700;
    font-size: 10px;
    line-height: 10px;
    letter-spacing: -0.03em;
    color: rgba(255, 255, 255, 0.5);

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 14px;
        line-height: 105%;
    }
`;

export const WishlistItemInner = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 4px;
`;

export const InfoWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    height: 17px;
`;

export const WishlistName = styled.a`
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: -0.02em;
    color: #ffffff;
    display: flex;
    align-items: flex-end;

    min-height: 17px;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 18px;
        line-height: 105%;
        letter-spacing: -0.03em;
    }
`;

export const EndWrapper = styled.div`
    position: absolute;
    right: 25px;
    top: 50%;
    transform: translateY(-50%);
`;

export const Radio = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0;
    gap: 10px;
    width: 20px;
    height: 20px;
    border: 1.5px solid #523df1;
    border-radius: 100px;
    transition: 0.3s;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    div {
        width: 10px;
        height: 10px;
        background: #523df1;
        flex: none;
        order: 0;
        flex-grow: 0;
        opacity: 1;
        transition: 0.3s;
        border-radius: 50%;
    }
`;
